import Loader from "../common/Loader";
import ConfigureTab from "./ConfigureTab";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import { TeamsFxContext } from "./TeamsFxContext";
import RemoveTab from "./RemoveTab";
import ContactSales from "./ContactSales";
import InviteBotHelpDialog from "./InviteBotHelpDialog";
import SidePanel from "./SidePanel";
import AdhocSidePanel from "./AdhocSidePanel";
import { useTeamsLogin } from "../../hooks/user";
import { HashRouter, Route, Routes } from "react-router-dom";
import { OrganizationProvider } from "../context/organization/OrganizationProvider";
import { RoomProvider } from "../context/room/RoomProvider";
import { Settings } from "../common/dialogs/SettingsDialog";
import Header from "../Header";
import { useTeamsMeetingType } from "../../hooks/teams";

function MeetingTypeRouter() {
  const meetingType = useTeamsMeetingType();
  if (meetingType === "adhoc") {
    return <AdhocSidePanel />;
  }
  return <SidePanel />;
}

function TeamsAuthenticator(props: { children: React.ReactNode }) {
  const { loading } = useTeamsLogin();

  if (loading) {
    return <Loader />;
  }

  return <>{props.children}</>;
}

export default function TeamsRouter() {
  // Init teams app
  const { loading, teamsUserCredential } = useTeamsUserCredential({
    initiateLoginEndpoint:
      import.meta.env.VITE_TEAMS_START_LOGIN_PAGE_URL ??
      "https://localhost:5173/auth-start.html",
    clientId:
      import.meta.env.VITE_TEAMS_CLIENT_ID ??
      "9b234b7b-9c76-4a2d-aef7-710a99c91c62",
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <TeamsFxContext.Provider value={{ teamsUserCredential }}>
      <TeamsAuthenticator>
        <HashRouter>
          <Routes>
            {/* TODO: Update manifest (requires re-submit to teams store) */}
            <Route
              path="/tab"
              element={
                <>
                  <Header hideUserNav={true} disableLogoClick={true} />
                  <ContactSales />
                </>
              }
            />
            <Route
              path="/configure"
              element={
                <>
                  <OrganizationProvider>
                    <ConfigureTab />
                  </OrganizationProvider>
                </>
              }
            />
            <Route
              path="/teams/room/:id"
              element={
                <>
                  <RoomProvider>
                    <SidePanel />
                  </RoomProvider>
                </>
              }
            />
            <Route
              path="/teams/room/:id/debug"
              element={
                <>
                  <RoomProvider>
                    <MeetingTypeRouter />
                  </RoomProvider>
                </>
              }
            />
            <Route
              path="/teams/settings/:id"
              element={
                <>
                  <RoomProvider>
                    <Settings
                      hiddenCategories={["audio", "video", "text-translation"]}
                      teams={true}
                    />
                  </RoomProvider>
                </>
              }
            />
            <Route
              path="/teams/invite-bot-help"
              element={<InviteBotHelpDialog />}
            />
            <Route path="/teams/room/:id/remove" element={<RemoveTab />} />
          </Routes>
        </HashRouter>
      </TeamsAuthenticator>
    </TeamsFxContext.Provider>
  );
}
